
import React from 'react';
import { Category, Account } from '@/types';
import { CategoryItem } from './CategoryItem';

interface CategoryItemContentProps {
  category: Category;
  accounts: Account[];
  onDrop: (accountId: string, categoryId: string) => void;
  onToggle: (categoryId: string) => void;
  expanded: Set<string>;
  level: number;
  onEdit: (category: Category) => void;
  onRemoveAccount?: (accountId: string) => void;
  onMoveUp?: (categoryId: string, parentId: string | null) => void;
  onMoveDown?: (categoryId: string, parentId: string | null) => void;
  onDeleteCategory?: (categoryId: string) => void;
  onSelect?: (category: Category) => void;
  isSelected?: boolean;
  selectedCategory?: Category | null;
}

export const CategoryItemContent = ({
  category,
  accounts,
  onDrop,
  onToggle,
  expanded,
  level,
  onEdit,
  onRemoveAccount,
  onMoveUp,
  onMoveDown,
  onDeleteCategory,
  onSelect,
  isSelected,
  selectedCategory
}: CategoryItemContentProps) => {
  console.log('CategoryItemContent rendering:', {
    categoryName: category.name,
    level,
    childrenCount: category.children.length,
    isSelected,
    selectedCategoryId: selectedCategory?.id
  });

  return (
    <div className="animate-tree-expand">
      {category.children.map((child, index) => (
        <CategoryItem
          key={child.id}
          category={child}
          accounts={accounts}
          onDrop={onDrop}
          onToggle={onToggle}
          expanded={expanded}
          level={level + 1}
          index={index}
          onEdit={onEdit}
          totalItems={category.children.length}
          parentId={category.id}
          onRemoveAccount={onRemoveAccount}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onDeleteCategory={onDeleteCategory}
          isFirst={index === 0}
          isLast={index === category.children.length - 1}
          onSelect={onSelect}
          isSelected={isSelected}
          selectedCategory={selectedCategory}
        />
      ))}
    </div>
  );
};
